module.exports = __webpack_public_path__ + "img/login_bg.1c29dec6.png";